// extracted by mini-css-extract-plugin
export var quantityInput = "_g7-0";